module.exports = __webpack_public_path__ + "static/img/banner-img.3081a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/helpCenter/banner-img.png
// module id = mL8i
// module chunks = 44